import React from 'react';

import { Document, Page, Text, View } from '@react-pdf/renderer';

import TablePDF from './TablePDF';
import KeyValuePDF from '../shared/KeyValuePDF';
import GlosaryColorsPDF from '../shared/GlosaryColorsPDF';
import GlosaryAbreviationsPDF from '../shared/GlosaryAbreviationsPDF';
import DividerPDF from '../shared/DividerPDF';
import { mapHolidaysReportData } from './mapReportData';
import { getTablePDFStyle } from '../../constants';
import EmptyUserDataPDF from '../shared/EmptyUserDataPDF';
import { isTimeTrackerFlatReportEmpty } from '../../../utils/isTimeTrackerReportEmpty';

/**
 * ReportPDF component specific for Attendance report with flat structure
 * @param {Object} props - Component props
 * @param {Object} props.data - Attendance data in flat structure (employeeId -> reportObject)
 * @param {string} props.orientation - PDF orientation ('portrait' or 'landscape')
 * @param {string} props.title - Report title
 * @param {boolean} props.includeGlosary - Whether to include glossary
 * @param {string[]} props.emptyUserDataLines - Lines to show when report is empty
 */
const ReportPDFAttendance = ({
  data = {},
  orientation = 'portrait',
  title,
  includeGlosary = true,
  emptyUserDataLines = [],
}) => {
  const styles = getTablePDFStyle();
  const isEmpty = isTimeTrackerFlatReportEmpty(data);

  return (
    <Document>
      <Page size="A4" orientation={orientation} style={styles.page}>
        <View height={410}>
          <View>
            <Text style={styles.title}>{title}</Text>
          </View>
          {includeGlosary && (
            <View>
              <View>
                <GlosaryAbreviationsPDF />
              </View>
              <View>
                <GlosaryColorsPDF />
              </View>
            </View>
          )}
          {isEmpty ? (
            <EmptyUserDataPDF lines={emptyUserDataLines} styles={styles} />
          ) : (
          mapHolidaysReportData(
            data,
            ({ id, employee, employer, columns, source, summary, footer }) => {
              const columnsToRemove = ['id'];
              const columnsToKeep = columns.filter(e => !columnsToRemove.includes(e.dataIndex));
              const summaryToKeep = summary
                ? [
                    ...summary,
                    ...Array(Math.max(0, columnsToKeep.length - summary.length)).fill(''),
                  ]
                : [];

              return (
                <View wrap={true} key={id} style={styles.cardReport}>
                  <TablePDF
                    headerSection={
                      <View>
                        <View style={styles.infoHeader}>
                          {employee.map(({ label, value }) => (
                            <KeyValuePDF key={label} label={label} value={value} />
                          ))}
                        </View>

                        {employer.length > 0 && <DividerPDF />}

                        <View style={styles.infoHeader}>
                          {employer.map(({ label, value }) => (
                            <KeyValuePDF key={label} label={label} value={value} />
                          ))}
                        </View>
                      </View>
                    }
                    key={id}
                    data={source}
                    headers={columnsToKeep}
                    summary={summaryToKeep}
                    footer={footer}
                  />
                </View>
              );
            },
          )
          )}
        </View>
      </Page>
    </Document>
  );
};

export default ReportPDFAttendance;
